import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IAnalyticTagsRepository } from "./IAnalyticTagsRepository";
import { AnalyticTags } from "src/app/models/AnalyticGroups/analytic-tags";

@Injectable({ providedIn: 'root' })
export class AnalyticTagsRepository extends GenericRepository<any> implements IAnalyticTagsRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/AnalyticTags', environment.urlAddress);
    }

    NavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.Get('NavRec/' + navType + '/' + currentIndex);
    }

    GetAnalyticTagByAccountCode(code: string): Observable<ResponseModel> {
        return this.Get('GetAnalyticTagByAccountCode/' + code);
    }

    GetRec(code: string): Observable<ResponseModel> {
        return this.Get('GetRec/' + code);
    }

    SearchRec(analyticGroupCode: string = ""): Observable<ResponseModel> {
        return this.Get('SearchRec/' + analyticGroupCode);
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<ResponseModel> {

        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }

        return this.Get('SelectAll/' + currentPage + '/' + recordsPerPage + '/' + filterText);
    }

    SaveRec(item: AnalyticTags): Observable<ResponseModel> {
        return this.PostData('/SaveRec/', item);
    }

    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('DeleteRec/' + code);
    }    
}